import axios from "axios";
import { signOut } from "firebase/auth";
import StorageUtils from "../utils/StorageUtils";
import { firebaseAuth } from "./FirebaseConfig";
import { obterTokenAtualizado, sessaoExpirada } from "../utils/sessao";

const api = axios.create({
  // baseURL: "https://api-agriholmes-prov.azurewebsites.net/api/",
  // baseURL: "https://sistema.pontualsys.com.br/api-agriholmes/api/",
  baseURL: process.env.REACT_APP_API_URL ?? "https://desenvolvimento.painel-agholmes-1.com.br/api/",
  timeout: 120000
});

/** DEVN3-780: código que a API devolve no 401 de usuário inativo (login e sessão aberta). */
export const CODIGO_USUARIO_INATIVO = 'USUARIO_INATIVO';
/** Mensagem que a tela de login mostra depois de derrubar a sessão (sessionStorage, lida uma vez). */
export const CHAVE_MOTIVO_LOGOUT = 'motivo-logout';

export async function encerrarSessao(motivo?: string): Promise<void> {
  await StorageUtils.clearStorage();
  if (motivo) {
    try {
      sessionStorage.setItem(CHAVE_MOTIVO_LOGOUT, motivo);
    } catch {
      // storage indisponível: o usuário só não vê o motivo no login
    }
  }
  try {
    await signOut(firebaseAuth);
  } catch {
    // sem sessão do Firebase para encerrar
  }
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
}

api.interceptors.request.use(
  async (config: any) => {
    const tokenGuardado = await StorageUtils.getToken();

    if (!tokenGuardado) {
      return config
    }

    // DEVN3-760: sessões anteriores ao deploy não têm a hora do login; contam a partir daqui.
    const inicio = StorageUtils.getSessaoInicio();
    if (inicio === null) {
      StorageUtils.setSessaoInicio(Date.now());
    } else if (sessaoExpirada(inicio)) {
      await encerrarSessao();
      throw new axios.Cancel('Sessão expirada');
    }

    await firebaseAuth.authStateReady();
    const accessToken = await obterTokenAtualizado(firebaseAuth.currentUser, tokenGuardado);

    if (accessToken !== tokenGuardado) {
      StorageUtils.setToken(accessToken);
    }

    config.headers.Authorization = `Bearer ${accessToken}`

    return config
  },
  (err: any) => Promise.reject(err)
)

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error: any) => {
    if (error?.response?.status === 401) {
      const data = error.response.data;
      await encerrarSessao(data?.codigo === CODIGO_USUARIO_INATIVO ? data.message : undefined);
      return Promise.reject(error);
    }

    if (error?.response?.data) {
      let data = error.response.data;

      if (data instanceof Blob) {
        try {
          const text = await data.text();
          const parsed = JSON.parse(text);
          data = parsed.message || parsed.error || text;
        } catch {
          data = 'Erro desconhecido';
        }
      } else if (typeof data === 'object' && data !== null) {
        data = data.message || data.error || JSON.stringify(data);
      }

      return Promise.reject({ message: data });
    }

    return Promise.reject(error);
  }
)

export default api;